export const ACTION_CODE = 'DASHBOARD_CONSULTANT_WORKLOAD' + '_ACTION';
